//@flow
import * as React from 'react';
import {
    Dialog,
    DialogHeader,
    Heading,
    DialogContent,
    Text,
    DialogFooter,
    Button
} from '@locus-taxy/neo-ui';
import { navigationPromptFactory } from 'common/components/core/router';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AlertDialog = ({ isOpen, onCancel, onConfirm }) => {
    const { t } = useTranslation('translations');
    return (
        <Dialog isOpen={isOpen} sticky onDismiss={onCancel}>
            <DialogHeader>
                <Heading truncated>{t('leaveThisPage')}</Heading>
            </DialogHeader>
            <DialogContent>
                <Text fontSize={2}>{t('unsavedChangesWillBeLost')}</Text>
            </DialogContent>
            <DialogFooter>
                <Button onClick={onCancel}>{t('stay')}</Button>
                <Button appearance="solid" palette="danger" onClick={onConfirm}>
                    {t('leave')}
                </Button>
            </DialogFooter>
        </Dialog>
    );
};

const NavigationPrompt = navigationPromptFactory({
    Prompt: AlertDialog
});

export const TerritoryAddEditContext: React$Context<{
    isNavigationDisabled: boolean,
    enableNavigation: () => void,
    disableNavigation: () => void,
    onDismissTerritoryCreation: (reload?: boolean) => void,
    ...
}> = React.createContext({});

const TerritoryAddEditProvider = (props: {
    children: React.Node,
    reloadMaster: () => void
}): React.Node => {
    const history = useHistory();
    const { location } = history;
    const { reloadMaster } = props;
    const [navigationDisabled, setNavigationDisabled] = React.useState(false);

    const enableNavigation = React.useCallback(() => {
        setNavigationDisabled(false);
    }, []);

    const disableNavigation = React.useCallback(() => {
        setNavigationDisabled(true);
    }, []);

    const onDismissTerritoryCreation = React.useCallback(
        (reload: boolean = false) => {
            if (reload) {
                reloadMaster();
            }
            history.replace(history.location.pathname);
        },
        [history, reloadMaster]
    );

    return (
        <TerritoryAddEditContext.Provider
            value={{
                isNavigationDisabled: navigationDisabled,
                enableNavigation,
                disableNavigation,
                onDismissTerritoryCreation
            }}
        >
            {props.children}
            <NavigationPrompt
                when={navigationDisabled}
                whiteListedPathnames={[
                    `${location.pathname}${location.search}`
                ]}
                searchQueryCheck
            />
        </TerritoryAddEditContext.Provider>
    );
};

export default TerritoryAddEditProvider;
